import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";
import { RouteLink } from "shared/components/link/RouteLink";

export interface LinkButtonProps extends ButtonProps {
  linkTo: string;
}

export const LinkButton = React.forwardRef<HTMLButtonElement, LinkButtonProps>(
  ({ linkTo, children, ...otherProps }, ref) => (
    <Button as={RouteLink} to={linkTo} ref={ref} {...otherProps}>
      {children}
    </Button>
  ),
);
LinkButton.displayName = "LinkButton";
